import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    createContactPerson as createContactPersonApi,
    updateContactPerson as updateContactPersonApi,
    getAllContactPerson as getAllContactPersonApi,
    getContactPerson as getContactPersonApi,
} from './api';

// actions
import { contactPersonApiResponseSuccess, contactPersonApiResponseError } from './actions';

// constants
import { ContactPersonActionTypes } from './constants';

type ContactPersonData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Contact Person
 * @param {*} payload
 */
function* AddContactPerson({ payload, type }: ContactPersonData): SagaIterator {
    try {
        const response = yield call(createContactPersonApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                contactPersonApiResponseSuccess(
                    ContactPersonActionTypes.ADD_CONTACT_PERSON,
                    data,
                    'Contact Person has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Contact Person!`;
            if (message) msg = message;
            yield put(
                contactPersonApiResponseSuccess(
                    ContactPersonActionTypes.ADD_CONTACT_PERSON,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            contactPersonApiResponseError(ContactPersonActionTypes.ADD_CONTACT_PERSON, [], error, 404, true, false)
        );
    }
}

/**
 * Edit Contact Person
 * @param {*} payload
 */
function* EditContactPerson({ payload, type }: ContactPersonData): SagaIterator {
    try {
        const response = yield call(updateContactPersonApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                contactPersonApiResponseSuccess(
                    ContactPersonActionTypes.EDIT_CONTACT_PERSON,
                    data,
                    'Contact Person Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit Contact Person!`;
            if (message) msg = message;
            yield put(
                contactPersonApiResponseSuccess(
                    ContactPersonActionTypes.EDIT_CONTACT_PERSON,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            contactPersonApiResponseError(ContactPersonActionTypes.EDIT_CONTACT_PERSON, [], error, 404, true, false)
        );
    }
}

/**
 * Fetch Contact Person
 * @param {*} payload
 */
function* GetContactPerson({ payload, type }: ContactPersonData): SagaIterator {
    try {
        const response = yield call(getContactPersonApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                contactPersonApiResponseSuccess(
                    ContactPersonActionTypes.GET_CONTACT_PERSON,
                    data,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Contact Person!`;
            if (message) msg = message;
            yield put(
                contactPersonApiResponseSuccess(
                    ContactPersonActionTypes.GET_CONTACT_PERSON,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            contactPersonApiResponseError(ContactPersonActionTypes.GET_CONTACT_PERSON, [], error, 404, true, false)
        );
    }
}

/**
 * Fetch Contact Persons
 * @param {*} payload
 */
function* GetContactPersons({ payload, type }: ContactPersonData): SagaIterator {
    try {
        const response = yield call(getAllContactPersonApi, payload);
        const { data, message, success, code } = response.data;
        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                contactPersonApiResponseSuccess(
                    ContactPersonActionTypes.GET_CONTACT_PERSONS,
                    responseData,
                    '',
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Contact Person Listing!`;
            if (message) msg = message;
            yield put(
                contactPersonApiResponseSuccess(
                    ContactPersonActionTypes.GET_CONTACT_PERSONS,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            contactPersonApiResponseError(ContactPersonActionTypes.GET_CONTACT_PERSONS, [], error, 404, true, false)
        );
    }
}

export function* watchGetContactPerson() {
    yield takeEvery(ContactPersonActionTypes.GET_CONTACT_PERSON, GetContactPerson);
}

export function* watchAddContactPerson() {
    yield takeEvery(ContactPersonActionTypes.ADD_CONTACT_PERSON, AddContactPerson);
}

export function* watchEditContactPerson(): any {
    yield takeEvery(ContactPersonActionTypes.EDIT_CONTACT_PERSON, EditContactPerson);
}

export function* watchGetContactPersons(): any {
    yield takeEvery(ContactPersonActionTypes.GET_CONTACT_PERSONS, GetContactPersons);
}

function* contactPersonSaga() {
    yield all([
        fork(watchGetContactPerson),
        fork(watchGetContactPersons),
        fork(watchEditContactPerson),
        fork(watchAddContactPerson),
    ]);
}

export default contactPersonSaga;
